import { Pipe, PipeTransform } from '@angular/core';
import { generateAnArrayWithIndexes } from '../utils';

@Pipe({
  name: 'bannerIndex'
})
export class BannerIndexPipe implements PipeTransform {

  transform(index: number): boolean {
    const indexses: number[] = generateAnArrayWithIndexes(50, 4, 5);
    if (indexses.includes(index)) {
        return true;
    }
    return false;
  }

}
